<template>
  <div class="allthat_survey">
    <!-- 헤더 -->
    <Head type='back' title="설문 참여" />
    <div id="stamp_survey">
      <div class="survey_cont text">
        <div class="bar"></div>
        <h2>임진강변 생태탐방로 설문</h2>
        <div class="desc">
          안녕하세요?<br/>
          파주 임진강변 생태탐방로 운영에 대한 참가자들의 의견을 듣고 향후 프로그램 개선 등을 위한 목적으로 설문을 실시하고 있습니다. 본 설문은 다른 용도로 사용하지 않을 것이니 성실하게 답변해주시기 바랍니다. 감사합니다.
        </div>
      </div>
      <div class="survey_cont text">
        <div class="title">
          개인정보 수집 및 이용 동의<br>
          <em>* 필수 항목입니다.</em>
        </div>
        <div class="contents">
          <p>설문에서 수집하는 개인정보는 기념품(인증서, 선물, 기념품 등)을 전달(우편 또는 택배)하기 위한 용도로만 사용되며 제3자에게 제공되거나 다른 목적으로 사용되지 않습니다.</p>
          <ul class="info">
            <li>
              · 수집하는 개인정보 : 이름(실명), 휴대폰번호, 주소, 생년월일
            </li>
            <li>
              · 개인정보 보관기간 : 1년
            </li>
          </ul>
          <p>개인정보 수집 및 이용에 동의하십니까?</p>
          <div class="row">
            <div class="radio">
              <input id="agree1" v-model="agree" value="Y" type="radio" name="agree">
              <label for="agree1">동의</label>
              <input id="agree2" v-model="agree" value="N" type="radio" name="agree">
              <label for="agree2">비동의</label>
            </div>
          </div>
        </div>
      </div>
      <!-- 성별 -->
      <div class="survey_cont" id="sv1">
        <div class="sur_title">
          1. 성별
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur1_1" v-model="params.question_1" value="남자" type="radio" name="survey_1">
            <label for="sur1_1">남자</label>
            <input id="sur1_2" v-model="params.question_1" value="여자" type="radio" name="survey_1">
            <label for="sur1_2">여자</label>
          </div>
        </div>
      </div>
      <!-- 연령 -->
      <div class="survey_cont" id="sv2">
        <div class="sur_title">
          2. 연령
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur2_1" v-model="params.question_2" value="10세이상~20세미만" type="radio" name="survey_2">
            <label for="sur2_1">10세이상~20세미만</label>
            <input id="sur2_2" v-model="params.question_2" value="20세이상~30세미만" type="radio" name="survey_2">
            <label for="sur2_2">20세이상~30세미만</label>
            <input id="sur2_3" v-model="params.question_2" value="30세이상~40세미만" type="radio" name="survey_2">
            <label for="sur2_3">30세이상~40세미만</label>
            <input id="sur2_4" v-model="params.question_2" value="40세이상~50세미만" type="radio" name="survey_2">
            <label for="sur2_4">40세이상~50세미만</label>
            <input id="sur2_5" v-model="params.question_2" value="50세이상~60세미만" type="radio" name="survey_2">
            <label for="sur2_5">50세이상~60세미만</label>
            <input id="sur2_6" v-model="params.question_2" value="60세이상~70세미만" type="radio" name="survey_2">
            <label for="sur2_6">60세이상~70세미만</label>
            <input id="sur2_7" v-model="params.question_2" value="70세이상" type="radio" name="survey_2">
            <label for="sur2_7">70세이상</label>
          </div>
        </div>
      </div>
      <!-- 거주지 -->
      <div class="survey_cont" id="sv3">
        <div class="sur_title">
          3. 거주지
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur3_1" v-model="params.question_3" value="서울특별시" type="radio" name="survey_3">
            <label for="sur3_1">서울특별시</label>
            <input id="sur3_2" v-model="params.question_3" value="경기도" type="radio" name="survey_3">
            <label for="sur3_2">경기도</label>
            <input id="sur3_3" v-model="params.question_3" value="강원도" type="radio" name="survey_3">
            <label for="sur3_3">강원도</label>
            <input id="sur3_4" v-model="params.question_3" value="충청도" type="radio" name="survey_3">
            <label for="sur3_4">충청도</label>
            <input id="sur3_5" v-model="params.question_3" value="경상도" type="radio" name="survey_3">
            <label for="sur3_5">경상도</label>
            <input id="sur3_6" v-model="params.question_3" value="전라도" type="radio" name="survey_3">
            <label for="sur3_6">전라도</label>
            <input id="sur3_7" v-model="params.question_3" value="제주도" type="radio" name="survey_3">
            <label for="sur3_7">제주도</label>
            <input id="sur3_8" v-model="params.question_3" value="인천광역시" type="radio" name="survey_3">
            <label for="sur3_8">인천광역시</label>
            <input id="sur3_9" v-model="params.question_3" value="부산광역시" type="radio" name="survey_3">
            <label for="sur3_9">부산광역시</label>
            <input id="sur3_10" v-model="params.question_3" value="광주광역시" type="radio" name="survey_3">
            <label for="sur3_10">광주광역시</label>
            <input id="sur3_11" v-model="params.question_3" value="대전광역시" type="radio" name="survey_3">
            <label for="sur3_11">대전광역시</label>
          </div>
        </div>
      </div>
      <!-- 신청 경로 -->
      <div class="survey_cont" id="sv4">
        <div class="sur_title">
          4. 신청 경로
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur4_1" v-model="params.question_4" value="TV, 라디오" type="radio" name="survey_4">
            <label for="sur4_1">TV, 라디오</label>
            <input id="sur4_2" v-model="params.question_4" value="광고, 관련 기사" type="radio" name="survey_4">
            <label for="sur4_2">광고, 관련 기사</label>
            <input id="sur4_3" v-model="params.question_4" value="인터넷" type="radio" name="survey_4">
            <label for="sur4_3">인터넷</label>
            <input id="sur4_4" v-model="params.question_4" value="권유" type="radio" name="survey_4">
            <label for="sur4_4">권유</label>
            <input id="sur4_5" v-model="params.question_4" value="기타" type="radio" name="survey_4">
            <label for="sur4_5">
              기타: <input type="text" v-model="etc.etc_4" class="etc etc_4">
            </label>
          </div>
        </div>
      </div>
      <!-- 누구와 함께 -->
      <div class="survey_cont" id="sv5">
        <div class="sur_title">
          5. 누구와 함께
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur5_1" v-model="params.question_5" value="가족" type="radio" name="survey_5">
            <label for="sur5_1">가족</label>
            <input id="sur5_2" v-model="params.question_5" value="친구" type="radio" name="survey_5">
            <label for="sur5_2">친구</label>
            <input id="sur5_3" v-model="params.question_5" value="직장동료" type="radio" name="survey_5">
            <label for="sur5_3">직장동료</label>
            <input id="sur5_4" v-model="params.question_5" value="동호회" type="radio" name="survey_5">
            <label for="sur5_4">동호회</label>
            <input id="sur5_5" v-model="params.question_5" value="혼자" type="radio" name="survey_5">
            <label for="sur5_5">혼자</label>
            <input id="sur5_6" v-model="params.question_5" value="기타" type="radio" name="survey_5">
            <label for="sur5_6">
              기타: <input type="text" v-model="etc.etc_5" class="etc etc_5">
            </label>
          </div>
        </div>
      </div>
      <!-- 생태탐방로에 대한 전체 만족도 -->
      <div class="survey_cont" id="sv6">
        <div class="sur_title">
          6. 생태탐방로에 대한 전체 만족도
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur6_1" v-model="params.question_6" value="매우불만족" type="radio" name="survey_6">
            <label for="sur6_1">매우불만족</label>
            <input id="sur6_2" v-model="params.question_6" value="불만족" type="radio" name="survey_6">
            <label for="sur6_2">불만족</label>
            <input id="sur6_3" v-model="params.question_6" value="보통" type="radio" name="survey_6">
            <label for="sur6_3">보통</label>
            <input id="sur6_4" v-model="params.question_6" value="만족" type="radio" name="survey_6">
            <label for="sur6_4">만족</label>
            <input id="sur6_5" v-model="params.question_6" value="매우만족" type="radio" name="survey_6">
            <label for="sur6_5">매우만족</label>
          </div>
        </div>
      </div>
      <!-- 이 지역에 대해 잘 이해하게 되었다 (동의하는 정도에 표시) -->
      <div class="survey_cont" id="sv7">
        <div class="sur_title">
          7. 이 지역에 대해 잘 이해하게 되었다 (동의하는 정도에 표시)
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur7_1" v-model="params.question_7" value="매우 그렇다" type="radio" name="survey_7">
            <label for="sur7_1">매우 그렇다</label>
            <input id="sur7_2" v-model="params.question_7" value="그런편이다" type="radio" name="survey_7">
            <label for="sur7_2">그런편이다</label>
            <input id="sur7_3" v-model="params.question_7" value="보통이다" type="radio" name="survey_7">
            <label for="sur7_3">보통이다</label>
            <input id="sur7_4" v-model="params.question_7" value="그렇지 않은편이다" type="radio" name="survey_7">
            <label for="sur7_4">그렇지 않은편이다</label>
            <input id="sur7_5" v-model="params.question_7" value="전혀 그렇지않다" type="radio" name="survey_7">
            <label for="sur7_5">전혀 그렇지않다</label>
          </div>
        </div>
      </div>
      <!-- 해설사의 해설은 만족스러웠다(동의하는 정도에 표시) -->
      <div class="survey_cont" id="sv8">
        <div class="sur_title">
          8. 해설사의 해설은 만족스러웠다(동의하는 정도에 표시)
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur8_1" v-model="params.question_8" value="매우 그렇다" type="radio" name="survey_8">
            <label for="sur8_1">매우 그렇다</label>
            <input id="sur8_2" v-model="params.question_8" value="그런편이다" type="radio" name="survey_8">
            <label for="sur8_2">그런편이다.</label>
            <input id="sur8_3" v-model="params.question_8" value="보통이다" type="radio" name="survey_8">
            <label for="sur8_3">보통이다.</label>
            <input id="sur8_4" v-model="params.question_8" value="그렇지 않은편이다" type="radio" name="survey_8">
            <label for="sur8_4">그렇지 않은편이다</label>
            <input id="sur8_5" v-model="params.question_8" value="매우 그렇다" type="radio" name="survey_8">
            <label for="sur8_5">전혀 그렇지않다</label>
          </div>
        </div>
      </div>
      <!-- 편의시설(화장실 등)은 만족스러운 수준이었다(동의하는 정도에 표시) -->
      <div class="survey_cont" id="sv9">
        <div class="sur_title">
          9. 편의시설(화장실 등)은 만족스러운 수준이었다(동의하는 정도에 표시)
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur9_1" v-model="params.question_9" value="매우 그렇다" type="radio" name="survey_9">
            <label for="sur9_1">매우 그렇다</label>
            <input id="sur9_2" v-model="params.question_9" value="그런편이다" type="radio" name="survey_9">
            <label for="sur9_2">그런편이다</label>
            <input id="sur9_3" v-model="params.question_9" value="보통이다" type="radio" name="survey_9">
            <label for="sur9_3">보통이다</label>
            <input id="sur9_4" v-model="params.question_9" value="그렇지 않은편이다" type="radio" name="survey_9">
            <label for="sur9_4">그렇지 않은편이다</label>
            <input id="sur9_5" v-model="params.question_9" value="전혀 그렇지않다" type="radio" name="survey_9">
            <label for="sur9_5">전혀 그렇지않다</label>
          </div>
        </div>
      </div>
      <!-- 주변 사람에게도 방문할 것을 권하고 싶다(동의하는 정도에 표시) -->
      <div class="survey_cont" id="sv10">
        <div class="sur_title">
          10. 주변 사람에게도 방문할 것을 권하고 싶다(동의하는 정도에 표시)
        </div>
        <div class="column">
          <div class="radio">
            <input id="sur10_1" v-model="params.question_10" value="매우 그렇다" type="radio" name="survey_10">
            <label for="sur10_1">매우 그렇다</label>
            <input id="sur10_2" v-model="params.question_10" value="그런편이다" type="radio" name="survey_10">
            <label for="sur10_2">그런편이다</label>
            <input id="sur10_3" v-model="params.question_10" value="보통이다" type="radio" name="survey_10">
            <label for="sur10_3">보통이다</label>
            <input id="sur10_4" v-model="params.question_10" value="그렇지 않은편이다" type="radio" name="survey_10">
            <label for="sur10_4">그렇지 않은편이다</label>
            <input id="sur10_5" v-model="params.question_10" value="전혀 그렇지않다" type="radio" name="survey_10">
            <label for="sur10_5">전혀 그렇지않다</label>
          </div>
        </div>
      </div>
      <!-- 기타 의견 -->
      <div class="survey_cont">
        <div class="sur_title">
          기타 의견을 자유롭게 적어주세요.
        </div>
        <div class="qstn_etc">
          <textarea v-model="params.subOpin" data-rows="1" tabindex="0" placeholder="내 답변"></textarea>
        </div>
      </div>
      <div class="survey_bottom">
          <div class="survey_btn">
              <button @click="submitSurvey" class="next">제출</button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Head from '@/components/Head.vue'
export default {
  name: 'View1',
  components: {
    Head
  },
  data () {
    return {
      agree: 'Y',
      params: {
        subOpin: ''
      },
      etc: {}
    }
  },
  computed: {
    ...mapState(['imjingangSurveySuccess'])
  },
  watch: {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    submitSurvey () {
      for (let i = 1; i <= 10; i++) {
        const sv = document.getElementById(`sv${i}`)
        // 설문 체크
        if (!this.params[`question_${i}`]) {
          alert(`${i}번 설문을 입력해 주세요.`)
          window.scrollTo(0, sv.offsetTop)
          return false
        }
        // 기타일 경우 입력한 텍스트 넣기
        if (this.params[`question_${i}`] === '기타') {
          if (!this.etc[`etc_${i}`]) {
            alert(`${i}번 설문의 기타 내용을 입력해 주세요.`)
            window.scrollTo(0, sv.offsetTop)
            return false
          }
          this.params[`question_${i}`] = this.etc[`etc_${i}`]
        }
      }
      this.$store.dispatch('imjingangRequestData', this.params)
    }
  }
}
</script>
